// Keys describe route templates, never a visitor's URL or route parameters.
export function isValidPageKey(key) {
  return (
    typeof key === "string" &&
    key.length <= 180 &&
    /^(?:[a-z][a-z0-9_]*|route:\/(?:[a-zA-Z0-9_:-]+\/?)*|route:not-found)$/.test(
      key
    )
  );
}

export function pageForRecord(record, parentPath = "") {
  if (!record || record.redirect || record.meta?.sitePageViewKey === false)
    return null;
  const canonical = record.aliasOf || record;
  const path =
    (canonical.path.startsWith("/")
      ? canonical.path
      : `${parentPath}/${canonical.path}`
    )
      .replace(/\/{2,}/g, "/")
      .replace(/\/$/, "") || "/";
  const template = path.includes("(.*)")
    ? "not-found"
    : path.replace(/\([^)]*\)[?*+]?/g, "").replace(/[?*+]/g, "");
  const key = canonical.meta?.sitePageViewKey || `route:${template}`;
  if (!isValidPageKey(key)) return null;
  return {
    key,
    path: template === "not-found" ? "404" : template,
    label:
      canonical.meta?.sitePageViewLabel ||
      (template === "/" ? "Home" : template),
  };
}

export function pageForRoute(route) {
  if (route.meta?.sitePageViewKey === false) return null;
  return pageForRecord(route.matched?.[route.matched.length - 1]);
}

export function collectTrackedPages(routes, parentPath = "") {
  const pages = routes.flatMap((record) => {
    const page = pageForRecord(record, parentPath);
    if (!page) return [];
    if (record.children?.length)
      return collectTrackedPages(record.children, page.path);
    return [page];
  });
  return Array.from(new Map(pages.map((page) => [page.key, page])).values());
}
